import React from "react";

import { Grid, Header } from "semantic-ui-react";

import { usePolicies } from "./hooks";
import { PrivacyPolicyRow } from "./components";

export function PrivacyPolicy() {
  const p = usePolicies();

  if (p.loading || p.isEmpty || p.numOfFetches === 0) return null;

  return (
    <div style={{ marginTop: "1em" }} data-test="privacy-policy-list">
      <div>
        <Header as="h1">Privacy Policy</Header>
      </div>
      <Grid columns={2} style={{ marginTop: "1em" }}>
        <Grid.Row style={{ padding: ".25em 0" }}>
          <Grid.Column>
            <Header as="h3">Version</Header>
          </Grid.Column>
          <Grid.Column>
            <Header as="h3">Accepted On</Header>
          </Grid.Column>
        </Grid.Row>
        {p.data.map((policy) => {
          return <PrivacyPolicyRow key={policy.id} {...policy} />;
        })}
      </Grid>
    </div>
  );
}

export default PrivacyPolicy;
